// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "TransactionRowMobile__textCenter__ZKBnv";
export const category = "TransactionRowMobile__category__-4a6k";
export const categoryCopy = "TransactionRowMobile__categoryCopy__CsAfL";
export const description = "TransactionRowMobile__description__Y4ErG";
export const tooltipIconWrapperOuter = "TransactionRowMobile__tooltipIconWrapperOuter__jV1FI";
export const tooltipIconWrapper = "TransactionRowMobile__tooltipIconWrapper__XUQJT";
export const right = "TransactionRowMobile__right__8Y0Fk";
export const actionButton = "TransactionRowMobile__actionButton__6SkcB";